var map = {
	"./10_wendy_lamoon_Felicitas_Ernst.webp": "./src/img/brands/spotify/10_wendy_lamoon_Felicitas_Ernst.webp",
	"./11_Paton_Felicitas_Ernst.webp": "./src/img/brands/spotify/11_Paton_Felicitas_Ernst.webp",
	"./12_Alexis_fernanzez_perrusky.webp": "./src/img/brands/spotify/12_Alexis_fernanzez_perrusky.webp",
	"./1_Chris_Deimon_Felicitas_Ernst.webp": "./src/img/brands/spotify/1_Chris_Deimon_Felicitas_Ernst.webp",
	"./2_Cofla_sta_Felicitas_Ernst.webp": "./src/img/brands/spotify/2_Cofla_sta_Felicitas_Ernst.webp",
	"./3_Black_papa_Felicitas_Ernst.webp": "./src/img/brands/spotify/3_Black_papa_Felicitas_Ernst.webp",
	"./4566eb87-dec3-487a-bef3-a167c4bd3c32_rw_1920.webp": "./src/img/brands/spotify/4566eb87-dec3-487a-bef3-a167c4bd3c32_rw_1920.webp",
	"./4_dj_boris_Felicitas_Ernst.webp": "./src/img/brands/spotify/4_dj_boris_Felicitas_Ernst.webp",
	"./5_LXS_GEMELXS.webp": "./src/img/brands/spotify/5_LXS_GEMELXS.webp",
	"./5_Sak2_Felicitas_Ernst.webp": "./src/img/brands/spotify/5_Sak2_Felicitas_Ernst.webp",
	"./7_Tommy_Leboso_Felicitas_Ernst.webp": "./src/img/brands/spotify/7_Tommy_Leboso_Felicitas_Ernst.webp",
	"./8_Wendy-zoe_Felicitas_Ernst.webp": "./src/img/brands/spotify/8_Wendy-zoe_Felicitas_Ernst.webp",
	"./9_esteban_el_flow_Felicitas_Ernst.webp": "./src/img/brands/spotify/9_esteban_el_flow_Felicitas_Ernst.webp",
	"./ALEXIS_MORELLINI_Felicitas_Ernst.webp": "./src/img/brands/spotify/ALEXIS_MORELLINI_Felicitas_Ernst.webp",
	"./Don_Paz_Felicitas_Ernst.webp": "./src/img/brands/spotify/Don_Paz_Felicitas_Ernst.webp",
	"./KIDIK_Felicitas_Ernst.webp": "./src/img/brands/spotify/KIDIK_Felicitas_Ernst.webp",
	"./Rosse_Loudi_Felicitas_Ernst.webp": "./src/img/brands/spotify/Rosse_Loudi_Felicitas_Ernst.webp",
	"./ailen_celeste.webp": "./src/img/brands/spotify/ailen_celeste.webp",
	"./don_paz__Felicitas_Ernst_.webp": "./src/img/brands/spotify/don_paz__Felicitas_Ernst_.webp",
	"./torycruz__Felicitas_Ernst.webp": "./src/img/brands/spotify/torycruz__Felicitas_Ernst.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/spotify sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";